module.exports = __webpack_public_path__ + "img/002.84470d72.png";